module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('v-card-title', {
    staticClass: "blue darken-1"
  }, [_c('h4', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("BankPDF-CRM 2.0")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Для входа в систему отправьте код авторизации телеграм боту @bankpdfbot:"), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.authcode))])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-3299cfbf","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 415
// module chunks = 0